
import { Draggable } from "react-beautiful-dnd";
import { ExerciseList } from "@/components/routines/ExerciseList";

interface DraggableExerciseItemProps {
  exercise: any;
  index: number;
  isPersonalPlan: boolean;
  showControls: boolean;
  canReorder: boolean;
  isCollapsed: boolean;
  onDeleteExercise: (exerciseId: string) => void;
  onUpdateExercise: (exerciseId: string, field: string, value: any) => void;
  onEditClick: (exercise: any) => void;
  onCollapseChange: (collapsed: boolean) => void;
  isEditDialogOpen: boolean;
  editExerciseName: string;
  onEditNameChange: (name: string) => void;
  onEditDialogOpenChange: (open: boolean) => void;
}

export const DraggableExerciseItem = ({
  exercise,
  index,
  isPersonalPlan,
  showControls,
  canReorder,
  isCollapsed,
  onDeleteExercise,
  onUpdateExercise,
  onEditClick,
  onCollapseChange,
  isEditDialogOpen,
  editExerciseName,
  onEditNameChange,
  onEditDialogOpenChange
}: DraggableExerciseItemProps) => {
  const isDragDisabled = !showControls || !canReorder;

  console.log("🏋️ DraggableExerciseItem render:", {
    exerciseId: exercise.id,
    exerciseName: exercise.name,
    index,
    isDragDisabled,
    canReorder,
    isPersonalPlan,
    isCollapsed
  });

  // If drag is disabled, render without Draggable wrapper
  if (isDragDisabled) {
    return (
      <div className="transition-none">
        <ExerciseList 
          exercises={[exercise]}
          onDeleteExercise={onDeleteExercise}
          onUpdateExercise={onUpdateExercise}
          onEditClick={onEditClick}
          isEditDialogOpen={isEditDialogOpen}
          editExerciseName={editExerciseName}
          onEditNameChange={onEditNameChange}
          onEditDialogOpenChange={onEditDialogOpenChange}
          showControls={showControls}
          isDragging={false}
          isCollapsed={isCollapsed}
          onCollapseChange={onCollapseChange}
          isPersonalPlan={isPersonalPlan}
        />
      </div>
    );
  }

  return (
    <Draggable 
      draggableId={exercise.id} 
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={provided.draggableProps.style}
          className={`
            ${snapshot.isDragging ? 'z-50 shadow-2xl transform rotate-2' : 'z-auto'}
            transition-none
          `}
        >
          <ExerciseList 
            exercises={[exercise]}
            onDeleteExercise={onDeleteExercise}
            onUpdateExercise={onUpdateExercise}
            onEditClick={onEditClick}
            isEditDialogOpen={isEditDialogOpen}
            editExerciseName={editExerciseName}
            onEditNameChange={onEditNameChange}
            onEditDialogOpenChange={onEditDialogOpenChange}
            showControls={showControls}
            dragHandleProps={provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            isCollapsed={isCollapsed}
            onCollapseChange={onCollapseChange}
            isPersonalPlan={isPersonalPlan}
          />
        </div>
      )}
    </Draggable>
  );
};
